import React from 'react';
import ContactManagement from '../../components/admin/contact/ContactManagement';

const ContactManagementPage = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Contact Management</h1>
        <p className="text-gray-600">Manage customer inquiries and messages</p>
      </div>
      <ContactManagement />
    </div>
  );
};

export default ContactManagementPage;